import { render, staticRenderFns } from "./PgaOfferEvaluationHeaderCustomerOrderEdit.vue?vue&type=template&id=d49a6bec&"
import script from "./PgaOfferEvaluationHeaderCustomerOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationHeaderCustomerOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d49a6bec')) {
      api.createRecord('d49a6bec', component.options)
    } else {
      api.reload('d49a6bec', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationHeaderCustomerOrderEdit.vue?vue&type=template&id=d49a6bec&", function () {
      api.rerender('d49a6bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/edit/sub-components/PgaOfferEvaluationHeaderCustomerOrderEdit.vue"
export default component.exports